import type { OperatorNodeProps } from "./OperatorNode";
import { PortHandle } from "../PortHandle";
import dico from "../../../../util/src/language/dico";
import { OperatorNodeCard } from "./OperatorNodeCard.js";

export function ObjectConstructorNode({
  node,
  setPortsMap,
  onPortMouseDown,
  onPortMouseUp,
  isPortConnected,
  onPortValueChange,
}: OperatorNodeProps) {
  if (node.type !== "operator") return null;
  return (
    <OperatorNodeCard>
      <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
        {node.ports
          .filter((port) => port.direction === "input")
          .map((port) => (
            <PortHandle
              key={port.id}
              node={node}
              port={port}
              setPortsMap={setPortsMap}
              onMouseDown={() => onPortMouseDown?.(node.id, port)}
              onMouseUp={() => onPortMouseUp?.(node.id, port)}
              isConnected={isPortConnected?.(node.id, port.id) ?? false}
              showLabel
              showValueInput={port.valueType !== "object"}
              onValueChange={(value) =>
                onPortValueChange?.(node.id, port.id, value)
              }
            />
          ))}
      </div>
      <span
        style={{
          fontSize: 22,
          fontWeight: 600,
          textTransform: "uppercase",
          color: "#333333",
          padding: "0 20px",
          whiteSpace: "nowrap",
        }}
      >
        {node.objectTypeName ?? dico().behavior.operators.constructObject}
      </span>
      <div>
        {node.ports
          .filter((port) => port.direction === "output")
          .map((port) => (
            <PortHandle
              key={port.id}
              node={node}
              port={port}
              setPortsMap={setPortsMap}
              onMouseDown={() => onPortMouseDown?.(node.id, port)}
              onMouseUp={() => onPortMouseUp?.(node.id, port)}
              isConnected={isPortConnected?.(node.id, port.id) ?? false}
            />
          ))}
      </div>
    </OperatorNodeCard>
  );
}
